import { ReportQueueRecordsStore } from '../../../../application/store';
import React from 'react';
export const MakeReportQueueRecordsStore = () => {
  return new ReportQueueRecordsStore();
};
